module.exports = __webpack_public_path__ + "static/media/modernbohomom-IG.1f93254b.PNG";